import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgHandshakeIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 60 60"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.984 13.07a2.5 2.5 0 0 1 1.59-.57h16.443a2.5 2.5 0 0 1 1.966.956l5.517 7.02V17.5H60v25H47.5v-3.75h-2.162l-12.819 7.477a5 5 0 0 1-5.038 0L14.662 38.75H12.5v3.75H0v-25h12.5v3.38zM12.5 23.71v12.54h2.162a2.5 2.5 0 0 1 1.26.34l12.818 7.478a2.5 2.5 0 0 0 2.52 0l11.852-6.914-9.123-11.269-6.715 2.766a5 5 0 0 1-6.245-2.143l-.405-.71a2.5 2.5 0 0 1 .35-2.953L28.357 15h-4.783l-9.933 8.18a2.5 2.5 0 0 1-1.141.53M31.79 15l-8.996 9.558.406.71a2.5 2.5 0 0 0 3.122 1.071l6.716-2.765a2.5 2.5 0 0 1 2.895.738l9.663 11.938H47.5V23.675a2.5 2.5 0 0 1-1.358-.88L40.017 15zM2.5 20v20H10V20zM50 20v20h7.5V20z"
    />
  </svg>
)
export default SvgHandshakeIcon
